import React, { useState } from 'react'
import Tabs, { TabPanel, TabTrigger, TabTriggerGroup } from '@zera-admin/tabs'
import { Column, Row } from '@zera-admin/page'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { string } from '@zera-admin/helpers'

import { getFieldOptions } from 'bi-tool/visualizations/visualization/getters'

import * as Styled from './GraphChartDefinitions.styled'
import { GraphChartDefinitionsProps } from './types'
import { GRAPH_FIELDS } from './constants'

const GrapCharts: React.FunctionComponent<GraphChartDefinitionsProps> = ({
  aggregations,
  fields,
  groups,
  onChange,
  options,
}) => {
  const [fieldOptions, setFieldOptions] = useState<SelectOptionProps[]>(
    getFieldOptions(fields)
  )

  const handleChangeFieldInput = (value: string) => {
    const option = {
      label: value,
      value,
    }
    const index = fieldOptions.findIndex(
      (reference) => reference.value === parseInt(option.value)
    )
    let optionsInstance = [...fieldOptions]

    if (value && index === -1) {
      optionsInstance[0] = option
    } else {
      optionsInstance = getFieldOptions(fields)
    }

    setFieldOptions(optionsInstance)
  }

  const renderTabs = () => {
    return (
      <Tabs id="tabs">
        <TabTriggerGroup>
          <TabTrigger>Veri / Tweet</TabTrigger>
        </TabTriggerGroup>
        <TabPanel>{renderTweetTab()}</TabPanel>
      </Tabs>
    )
  }

  const renderTweetTab = () => {
    const values = options?.fields || {}

    return GRAPH_FIELDS.map((tweetField, index) => (
      <Row key={index} xs={{ direction: 'column' }}>
        <Column>
          <Select
            name={tweetField.value}
            options={fieldOptions}
            onChange={(props) => {
              onChange({
                ...options,
                fields: {
                  ...options.fields,
                  [tweetField.value]: (props as SelectOptionProps)
                    .value as string,
                },
              })
            }}
            onInputChange={handleChangeFieldInput}
            value={
              values[tweetField.value]
                ? {
                    label: string.textify(values[tweetField.value]),
                    value: values[tweetField.value],
                  }
                : { label: '', value: '' }
            }
            label={tweetField.label}
            placeholder="Seçim yapınız"
          />
        </Column>
      </Row>
    ))
  }

  return <Styled.TweetDefinitions>{renderTabs()}</Styled.TweetDefinitions>
}

export default GrapCharts
